// @flow

import type { HierarchyState } from "./types";

export const onGetHierarchyTree = (state: HierarchyState) => () => {
  return {
    ...state,
    requestsInProgress: ++state.requestsInProgress,
  };
};

export const onGetHierarchyTreeSuccess = (state: HierarchyState) => ({ payload }: Object) => {
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    active: payload,
    error: null,
  };
};

export const onGetHierarchyTreeError = (state: HierarchyState) => ({ payload }: Object) => {
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    error: payload,
    success: false,
  };
};

export const onGetMyHierarchyTreeSuccess = (state: HierarchyState) => ({ payload }: Object) => {
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    myActive: payload,
    error: null,
  };
};

export const onGetMyHierarchyTreeError = (state: HierarchyState) => ({ payload }: Object) => {
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    error: payload,
    success: false,
  };
};

export const onResetMyHierarchyTree = (state: HierarchyState) => () => {
  return {
    ...state,
    myActive: null,
  };
};
